export default __webpack_public_path__ + "static/twif-thumb-1400-e417ca8c1a5b94f4618f23db5eb4f8a8.jpg";